<script>
import { SelectListSorted } from '../patterns'
import SvgIcon from '~/components/SvgIcon.vue'
import { getSegmentIcon } from '~/icons/segment'

export default {
  config: {
    title: 'Body Style',
    weight: 1,
    facet: 'segment'
  },
  components: {
    SelectListSorted,
    SvgIcon
  },
  methods: {
    getSegmentIcon
  }
}
</script>

<template>
  <SelectListSorted
    :facet="$options.config.facet"
    order="popularity"
  >
    <template #icon="{ value }">
      <SvgIcon :src="getSegmentIcon(value)" />
    </template>
  </SelectListSorted>
</template>

<style lang="scss">
.srp__filter--segment {
  .select-list-row svg:first-of-type {
    height: 60px;
    width: 60px;
  }
}
</style>
